import { AnimatedSprite } from "appworks/graphics/animation/animated-sprite";
import { Layers } from "appworks/graphics/layers/layers";
import { gameState } from "appworks/model/game-state";
import { Services } from "appworks/services/services";
import { Contract } from "appworks/utils/contracts/contract";
import { Tween } from "appworks/utils/tween";
import { gameLayers } from "game-layers";
import { MatrixComponent } from "slotworks/components/matrix/matrix-component";
import { SymbolComponent } from "slotworks/components/matrix/symbol/symbol-component";
import { AnticipationResult } from "slotworks/model/gameplay/records/results/anticipation-result";
import { TGRSoundEvent } from "tgr-sound-event-enum";

export class TGRMatrixComponent extends MatrixComponent {

    constructor(
        grid: number[],
        stops: number[],
        reelset: string[][],
        matrixLayer?: Layers,
        animationLayer?: Layers,
        public readonly symbolType: typeof SymbolComponent = SymbolComponent) {
        super(grid, stops, reelset, matrixLayer, animationLayer, symbolType);

        this.onAnticipationReel.add((reelIndex: number) => this.anticipationReel(reelIndex));
        this.onAnticipationEnd.add((reelIndex: number) => this.anticipationEnd(reelIndex));
    }

    public darkenReels(darken: boolean = true, fadeDuration: number = 500): Contract<void> {
        return new Contract<void>((resolve: (value?: any) => void) => {
            const tween = new Tween(gameLayers.MatrixForeground.elements.default.reel_darken);
            tween.to({alpha: Number(darken)}, fadeDuration);
            tween.onComplete(resolve);
            tween.start();
        });
    }

    protected anticipationReel(reelIndex: number): void {
        const anticipationResult: AnticipationResult = gameState.getCurrentGame().getCurrentRecord().getFirstResultOfType(AnticipationResult);
        const symbol: string = anticipationResult.anticipateSymbols[reelIndex][0].replace(/^QH[\+_].*/, "QH");

        gameLayers.Anticipation.setScene(symbol).then(() => {
            gameLayers.Anticipation.enableBoundsMask(true);
            for (let i: number = 0; i <= reelIndex; i++) {
                const animation: AnimatedSprite = gameLayers.Anticipation.getAnimatedSprite(`anticipation_${i}`);
                if (animation) {
                    if (i === reelIndex) {
                        Services.sound.customEvent(TGRSoundEvent[`anticipation_${symbol}`]);
                        animation.visible = true;
                        animation.playRange(0, 11, true);
                    } else {
                        Services.sound.customEvent(TGRSoundEvent.anticipation_end);
                        animation.stop();
                        animation.visible = false;
                    }
                }
            }
        });
    }

    protected anticipationEnd(reelIndex: number): void {
        gameLayers.Anticipation.defaultScene().execute();
    }
}
